import { Nav, Footer } from "../components/Nav";
import { useEffect } from "react";
import { HashLink } from "react-router-hash-link";

import meImg from "../images/Me.png";
import danceImg from "../images/Dance.png";
export default function Portfolio() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);
  return (
    <>
      <Nav />
      <main className="about-container">
        <section id="about-section">
          <h1 style={{ fontSize: "2rem" }}> About Me</h1>
          <h2 style={{ marginTop: "0" }}>🏔️ My Journey</h2>
          <p>
            Hi there! My name is Mandy Lin and this past December graduated from
            Santa Clara University with a major in Computer Science and a minor
            in Graphic Design.
          </p>
          <p>
            Throughout my undergraduate studies, I focused on front-end
            development and participated in various{" "}
            <HashLink to="/#project-section"> projects</HashLink> and{" "}
            <a
              href="https://devpost.com/software/webcrack"
              target="_blank"
              rel="noopener noreferrer"
            >
              competitions
            </a>
            . With my design skills, I always took on the UI design role, which
            became my first real exposure to UI/UX design. Over time, I realized
            that what excited me most wasn’t just building functionality but
            shaping how users interact with and feel about a product. This
            passion eventually led me to embark on a journey to start my career
            in UI/UX design!
          </p>
          <img src={meImg} alt="Photos of Mandy Lin" />
          <h2>🌟 Leadership</h2>
          <p>
            I've been an active board member of several campus clubs. Currently,
            I serve as the Media Officer for{" "}
            <a
              href="https://www.instagram.com/_daybreakofficial/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              Daybreak
            </a>{" "}
            and previously held the role of Director of Media for{" "}
            <a
              href="https://www.instagram.com/scuacmw/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              ACM-W
            </a>
            .
          </p>

          <h2>🧶 Craft Enthusiast</h2>
          <p>
            I love filling my downtime with all things craft, from crocheting to
            scrapbooking!
          </p>

          <h2>💃 Dancing</h2>
          <p>
            I'm passionate about dancing and performing, especially for the
            sense of community and teamwork it brings. You can find some of my
            dancing on{" "}
            <a
              href="https://www.youtube.com/@_daybreakofficial/featured"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              YouTube{" "}
            </a>
            or{" "}
            <a
              href="https://www.instagram.com/mandydrafts/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
            .
          </p>
          <img src={danceImg} alt="Photos of Mandy Lin" />
        </section>
      </main>

      <Footer />
    </>
  );
}
